<template>
  <div>
    <div class="detail container1">

      <div class="detail-header">
        <div class="main">
          <div class="img_box" v-for="(v,i) in activeImg" :key="i">
            <img v-lazy="v">
          </div>
        </div>
        <div class="swiper_box">
          <Swiper ref="mySwiper" :options="swiperOption">
            <swiper-slide :class="{'swiper-slide':true,active:imgActiveI===i}" v-for="(v,i) in previewImgList" :key="i" @click.native="setActiveImg(i)">
              <img v-lazy="v.filePath">
              <div class="mask_img"></div>
            </swiper-slide>
          </Swiper>
          <div class="swiper-button-next" v-show="previewImgList.length>5">
            <i class="myicon iconfont icon-xiayiye"></i>
          </div>
          <div class="swiper-button-prev" v-show="previewImgList.length>5">
            <i class="myicon iconfont icon-xiayiye-copy"></i>
          </div>
        </div>
      </div>

      <div class="detail-body">
        <div class="table-body">
          <h4 class="title">{{themeInfo.name}}</h4>
          <router-link class="more com_link" :to="{path:'/category',query:{styleSerNos:themeInfo.parentStyleSerNo}}" target="_blank">
            更多>>
          </router-link>
          <ul class="table-list">
            <li class="table-item" v-for="(v,i) in mixList" :key="i">

              <h3 class="name com_hidden">
                <router-link class="com_link" :to="{path:'/goodsDetails/'+v.serNo+'.html'}" target="_blank">
                  {{v.goodsName}}
                </router-link>
              </h3>

              <div class="sprice" style="padding:4px 0px 0px;">
                市场参考价：
                <span class="line_th">￥{{ v.salePrice | priceValue }}</span>
              </div>
              <div class="price">
                <p class="cprice" v-if="$cookies.isKey('ACCESS_TOKEN')">整装拎包价￥{{ v.clientSalePrice | priceValue}}</p>
                <p class="cprice cur_pointer" v-else style="font-size:14px;" @click.prevent.stop="$refs.diaLogin.elVisible = true;">登录查看多比价</p>
              </div>

              <router-link class="img_box mask" :to="{path:'/goodsDetails/'+v.serNo+'.html'}" target="_blank">
                <img class="img" v-lazy="v.mainPreviewImageFilePath" alt='图片加载失败' />
              </router-link>

              <div class="itr_box">
                <p class="itr com_hidden">
                  <router-link :to="{path:'/goodsDetails/'+v.serNo+'.html'}" target="_blank">
                    产品规格：{{v.attr1ContentName}}
                    {{v.attr2ContentName?"+"+v.attr2ContentName:""}}
                    {{v.attr3ContentName?"+"+v.attr3ContentName:""}}
                    {{v.attr4ContentName?"+"+v.attr4ContentName:""}}
                  </router-link>
                </p>
                <p class="itr com_hidden">
                  尺寸(mm)：
                  {{v.mixGoodsLength?v.mixGoodsLength+'*':""}}
                  {{v.mixGoodsWidth?v.mixGoodsWidth+'*':""}}
                  {{v.mixGoodsHeight?v.mixGoodsHeight:""}}
                </p>
                <p class="itr com_hidden">
                  <span>型号：{{v.goodsNo}}</span>
                </p>
                <p>
                  <span>购买数量：</span>
                  <el-input-number v-model="v.goodsCount" controls-position="right" :min="0" :max="999" size="mini"></el-input-number>
                </p>
              </div>
            </li>
          </ul>
        </div>

        <div :class="{'footer':true,fixed:isFixed}">
          <div class="select">已选 <span class="f30">{{selectedNumber}}</span> 件</div>
          <div class="price">整装拎包价：
            <span class="fwb">￥</span>
            <span class="f30">{{$cookies.isKey('ACCESS_TOKEN')?tokenSelectedPrice:selectedPrice | priceValue}}</span>
          </div>
          <el-button class="btn" type="primary" @click="goPlaceOrder">购物车结算</el-button>
        </div>
      </div>
    </div>
    <public-footer ref="pubFooter"></public-footer>
    <dialog-login ref="diaLogin" @updateLogin="updateLogin"></dialog-login>
  </div>
</template>

<script>
import {
  GetGoodsDetailThemeDetailByNo,
  GetSimpleThemeDetailByNo,
} from "@/pages/page1/api/modules/home";
import { BatchAddShopCart } from "@/pages/page1/api/modules/shoppingCart";
import DialogLogin from "@/pages/page1/components/dialogLogin.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  metaInfo: { title: "拎包套餐 - 多比商城" },
  components: {
    Swiper,
    SwiperSlide,
    DialogLogin,
  },
  data() {
    return {
      swiperOption: {
        direction: "vertical", //上下轮播
        spaceBetween: 15, //间隔距离
        autoplay: false,
        grabCursor: true,
        slidesPerView: 5,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
      },
      imgActiveI: 0,
      activeImg: [],
      themeInfo: {},
      previewImgList: [],
      mixList: [],
      isFixed: false,
    };
  },
  mounted() {
    this.getThemeDetail(this.$route.query.themeNo);
    this.getGoodsList(this.$route.query.themeNo);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getThemeDetail(themeNo) {
      GetGoodsDetailThemeDetailByNo({ themeNo }).then((res) => {
        // console.log("获取主题详情", res);
        this.previewImgList = res.data[0].previewImgList;
        this.setActiveImg(0);
      });
    },
    setActiveImg(val) {
      this.imgActiveI = val;
      if (this.previewImgList.length > 0) {
        this.activeImg[0] = this.previewImgList[this.imgActiveI].filePath || "";
      } else {
        this.activeImg[0] = "";
      }
    },
    getGoodsList(themeNo) {
      GetSimpleThemeDetailByNo({ themeNo }).then((res) => {
        // console.log("标配商品", res);
        this.themeInfo = res.data[0].themeInfo;
        this.mixList = res.data[0].mixList;
        this.mixList.forEach((v) => {
          this.$set(v, "goodsCount", v.addInMixCount);
          this.$set(v, "goodsMixId", v.id);
        });
      });
    },
    // 吸底
    handleScroll() {
      // 内容可视区域的高度加上溢出上下（滚动）的距离
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 可视高度
      let clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 页面被卷去的上高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 页面被卷去的下高度
      let scrollBottom = scrollHeight - clientHeight - scrollTop;
      // 底部footer高度+margin
      let footerHeight = this.$refs.pubFooter.$el.scrollHeight + 90;
      //   console.log(scrollBottom, footerHeight);
      scrollBottom <= footerHeight
        ? (this.isFixed = false)
        : (this.isFixed = true);
      if (scrollTop <= 240) {
        this.isFixed = false;
      }
    },
    goPlaceOrder() {
      if (this.selectedGoods.length === 0) {
        this.$alert("请至少选中一件商品", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          showClose: false,
        });
        return;
      }
      if (this.$cookies.isKey("ACCESS_TOKEN")) {
        let params = {
          regionCode: localStorage.getItem("_regionCode"),
          shoppingCartList: this.cartList,
        };
        BatchAddShopCart(params).then((res) => {
          // console.log("批量加入购物车", res);
          // 用购物车id代替原本id
          let newBusiness = JSON.parse(JSON.stringify(this.selectedBrands));
          newBusiness.forEach((item) => {
            item.shoppingCartList.forEach((v) => {
              let resItem = res.data.find((j) => j.goodsMixId === v.goodsMixId);
              if (resItem) {
                v.id = resItem.id;
                v.goodsCount = resItem.goodsCount;
              }
            });
          });
          // console.log(this.selectedBrands,newBusiness);
          // return
          // 选中的商品去订单生成
          let time = new Date().getTime();
          localStorage.setItem(
            "selectGoods_" + time,
            JSON.stringify(newBusiness)
          );
          let newUrl = this.$router.resolve({
            path: "/placeOrder",
            query: { id: time, byUrl: "shopCart" },
          });
          window.open(newUrl.href, "_self");
        });
      } else {
        this.$refs.diaLogin.elVisible = true;
      }
    },
    updateLogin(isLogin) {
      if (isLogin) {
        location.reload();
      }
    },
  },
  computed: {
    selectedGoods() {
      let arr = [];
      this.mixList.forEach((v) => {
        if (v.goodsCount > 0) {
          arr.push(v);
        }
      });
      return arr;
    },
    cartList() {
      let arr = [];
      this.selectedGoods.forEach((v) => {
        arr.push({
          goodsMixId: v.goodsMixId,
          goodsCount: v.goodsCount,
        });
      });
      return arr;
    },
    selectedNumber() {
      let num = 0;
      this.selectedGoods.forEach((v) => {
        num += v.goodsCount;
      });
      return num;
    },
    // 没登录
    selectedPrice() {
      let num = 0;
      this.selectedGoods.forEach((v) => {
        num += v.goodsCount * v.salePrice;
      });
      return num;
    },
    // 登录后
    tokenSelectedPrice() {
      let num = 0;
      this.selectedGoods.forEach((v) => {
        num += v.goodsCount * v.clientSalePrice;
      });
      return num;
    },
    selectedBrands() {
      let brandArr = [];
      // 品牌合并
      this.selectedGoods.forEach((item) => {
        let resItem = brandArr.find((v) => v.goodsBrandId === item.brandId);
        if (!resItem) {
          brandArr.push({
            goodsBrandId: item.brandId,
            goodsBrandName: item.brandName,
            shoppingCartList: [],
          });
        }
      });
      // 每个品牌下面的商品
      brandArr.forEach((item) => {
        this.selectedGoods.forEach((v) => {
          if (item.goodsBrandId == v.brandId) {
            item.shoppingCartList.push(v);
          }
        });
      });
      return brandArr;
    },
  },
};
</script>

<style lang="less" scoped>
.detail {
  padding-bottom: 50px;
  color: #333333;
  line-height: 1;
  font-size: 14px;
  position: relative;
  .detail-header {
    margin-top: 34px;
    display: flex;
    height: 595px;
    .main {
      width: 954px;
      height: 100%;
      margin-right: 18px;
      .img_box {
        width: 100%;
        height: 100%;
      }
    }
    .swiper_box {
      width: calc(100% - 954px - 18px);
      height: 100%;
      position: relative;
      .swiper-container {
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        padding-left: 32px;
        position: relative;
        z-index: 2;
        .swiper-wrapper {
          .swiper-slide {
            position: relative;
            &::before {
              display: none;
              content: "";
              width: 0;
              height: 0;
              position: absolute;
              left: -32px;
              top: 50%;
              margin-top: -8px;
              border-width: 8px 7px;
              border-style: solid;
              border-color: transparent @themeColor transparent transparent;
            }
            &::after {
              display: none;
              content: "";
              width: 0;
              height: 0;
              position: absolute;
              left: -30px;
              top: 50%;
              margin-top: -8px;
              border-width: 8px 7px;
              border-style: solid;
              border-color: transparent #ffffff transparent transparent;
            }
            &:hover {
              .mask_img {
                display: block;
              }
            }
          }
          .active {
            &::before,
            &::after {
              display: block;
            }
          }
        }
      }
      &::after {
        display: block;
        content: "";
        position: absolute;
        left: 14px;
        top: 0;
        width: 1px;
        height: 100%;
        background: @themeColor;
      }
      .swiper-button-next,
      .swiper-button-prev {
        top: auto;
        bottom: auto;
        left: 32px;
        right: auto;
        width: 186px;
        height: 22px;
        background-image: none;
        background: rgba(13, 24, 19, 0.2);
        color: #ffffff;
        z-index: 3;
        display: flex;
        justify-content: center;
        .myicon {
          font-size: 22px;
          width: 22px;
          height: 22px;
          display: block;
          transform: rotate(90deg);
          -ms-transform: rotate(90deg); /* IE 9 */
          -moz-transform: rotate(90deg); /* Firefox */
          -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
          -o-transform: rotate(90deg); /* Opera */
        }
      }
      .swiper-button-prev {
        top: 22px;
      }
      .swiper-button-next {
        bottom: 0px;
      }
      .swiper-button-disabled {
        pointer-events: auto; //打开鼠标样式
        cursor: not-allowed;
      }
    }
  }
  .detail-body {
    margin-top: 34px;
    margin-bottom: 90px;
    position: relative;
    .table-body {
      padding: 10px 30px 60px;
      background: #f4f4f4;
      .title {
        height: 75px;
        overflow: hidden;
        line-height: 75px;
        border-bottom: 1px solid #cacaca;
        text-align: center;

        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
      }
      .more {
        position: absolute;
        right: 30px;
        top: 56px;
        font-family: PingFang;
        font-weight: 500;
        color: #525252;
      }
      .table-list {
        display: flex;
        flex-wrap: wrap;
        .table-item {
          width: calc((100% - 60px) / 3);
          box-sizing: border-box;
          margin-right: 30px;
          margin-top: 40px;
          &:nth-child(3n) {
            margin-right: 0;
          }
          .name {
            font-size: 20px;
            font-weight: bold;
            line-height: 30px;
            height: 30px;
            color: #1a1a1a;
            a {
              color: #1a1a1a;
            }
          }
          .price {
            font-size: 16px;
            font-weight: bold;
            color: #ff0000;
            margin-bottom: 4px;
          }
          .img_box {
            display: block;
            width: 100%;
            height: 356px;
            margin-bottom: 16px;
          }
          .itr_box {
            color: #525252;
            font-size: 16px;
            .itr {
              height: 30px;
              line-height: 30px;
              a {
                color: #525252;
              }
            }
          }
        }
      }
    }
    .footer {
      width: @themeWidth;
      height: 90px;
      box-sizing: border-box;
      padding-left: 30px;
      background: #e4e4e4;
      display: flex;
      align-items: center;
      font-weight: 500;
      z-index: 3;
      position: absolute;
      bottom: -90px;
      left: auto;
      .export {
        font-size: 20px;
        font-weight: 500;
        margin-right: 350px;
        cursor: pointer;
        &:hover {
          color: @themeColor;
          .myicon {
            color: @themeColor;
          }
        }
        .myicon {
          font-size: 20px;
          color: #333333;
          padding-right: 16px;
        }
      }
      .select {
        font-size: 20px;
        color: #1a1a1a;
      }
      .fwb {
        font-weight: bold;
      }
      .f30 {
        font-size: 30px;
        font-weight: bold;
      }
      .price {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 200px;
        color: #f51616;
        font-size: 20px;
      }
      .btn {
        position: absolute;
        right: 0px;
        top: 0px;
        width: 180px;
        height: 100%;
        border-radius: 0;
        font-size: 20px;
      }
    }
    .fixed {
      position: fixed;
      bottom: 0px;
    }
  }
  .mask_img {
    cursor: pointer;
    width: 100%;
    height: 100%;
    background: #000000;
    opacity: 0.2;
    position: absolute;
    top: 0;
    left: 0;
    display: none;
  }
  .mask {
    position: relative;
    cursor: pointer;
    &::after {
      display: block;
      content: "";
      width: 100%;
      height: 100%;
      background: #000000;
      opacity: 0.2;
      position: absolute;
      top: 0;
      left: 0;
      display: none;
    }
    &:hover {
      &::after {
        display: block;
      }
    }
  }
}
</style>